import React from "react";
import { HeroProps } from "../types/appTypes";

const Hero: React.FC<HeroProps> = ({ title, text }) => {
  return (
    <header className="swiss-section !border-t-0 pt-7 lg:pt-9">
      <div className="swiss-grid">
        <div className="col-span-12 lg:col-span-2 mb-6 lg:mb-0">
          <span className="swiss-num">00 / Bogowi</span>
        </div>
        <div className="col-span-12 lg:col-span-10">
          <h1 className="text-[clamp(2.5rem,5.5vw,5rem)] font-black tracking-tightest leading-[0.95] text-ink max-w-[16ch]">
            {title}
          </h1>
          <p className="mt-6 text-body-lg text-ink-70 max-w-prose">{text}</p>
        </div>
      </div>
    </header>
  );
};

export default Hero;
